import {
  Box,
  Button,
  Image,
  HStack,
  Stack,
  Text,
  useMediaQuery,
  VStack
} from '@chakra-ui/react'
import { ArrowBackIcon } from '@chakra-ui/icons'
import { Link } from 'react-router-dom'
import useArea from '../../hooks/useArea'
import SessionStartLogo from '../../components/SessionStartLogo'
import useAuth from '../../hooks/useAuth'
import LogoutHeader from '../../components/LogoutHeader'
const quilmesImages = require.context('../../assets/images', true)

function ProductosPorArea () {
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')
  const { user } = useAuth()
  const [areas] = useArea()
  const handleReturn = () => {
    console.log('atras')
  }
  const handleClick = (editArea) => {
    sessionStorage.setItem('geoAreaDescription', JSON.stringify(editArea))
  }

  return (
    <Stack>
      <Box
        {...(isLargerThan768
          ? { display: 'flex', justifyContent: 'space-between' }
          : { display: 'none' })}
        alignItems={'center'}
        className='logo-home'
        paddingLeft={'5%'}
        paddingRight={'5%'}
      >
        <LogoutHeader />
      </Box>
      <HStack
        alignItems={'center'}
        borderBottom={' 1px solid #E1E1E1'}
        display={'flex'}
        h={'72px'}
        justifyContent={'space-between'}
        paddingLeft={'5%'}
        paddingRight={'5%'}
      >
        <Box>
          <Link to={'/home'} onClick={handleReturn}>
            <ArrowBackIcon
              color={'#0A0808'}
              h={6}
              marginLeft={{ base: '2', md: '5' }}
              marginRight={4}
              w={6}
            />
          </Link>
        </Box>
        <Text fontWeight={'bold'} paddingRight={{ base: '2rem', md: '6rem' }}>
          Productos por área geográfica
        </Text>
        <Box />
      </HStack>
      <VStack
        mx={'auto'}
        paddingBottom={'2rem'}
      >
        {areas
          .sort((a, b) =>
            a.description.toLowerCase() < b.description.toLowerCase() ? -1 : 1
          )
          .map((item) => (
            <Box
              key={item.geoAreaId}
              // display={'flex'}
              // justifyContent={'space-between'}
              borderBottom={' 1px solid #E1E1E1'}
              paddingBottom={'15px'}
              paddingTop={'15px'}
              textAlign={'left'}
              textTransform={'capitalize'}
              value={item.description}
              w={{ base: '90%', md: '50%' }}
            >
              <HStack
                marginTop={'-0.8rem'}
              >
                <Box
                  display={'flex'}
                  flexDirection={'column'}
                  width={'100%'}
                >
                  <Text
                    color={'#3B3939'}
                    display={'inline-block'}
                    fontSize={'16px'}
                    fontWeight={'400'}
                    lineHeight={'22px'}
                    w={'85%'}
                  >
                    {item.description}
                  </Text>
                </Box>
                <Link
                  marginTop={'1.5rem'}
                  to='/edit-products-area'
                  onClick={() => handleClick(item)}
                >
                  <Image
                    className='img-gestion'
                    src={quilmesImages('./flechaProducts.svg')}
                    w={'40px'}
                  />
                </Link>
              </HStack>

            </Box>
          ))}
      </VStack>
    </Stack>
  )
}

export default ProductosPorArea
